import React from "react";
import { TaskExecutionInstructionsStack } from "./TaskExecutionInstructionsStack";
import { TaskExecutionInstructionsScreen } from "./TaskExecutionInstructionsScreen";

import { useIntl } from "react-intl";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { useNavigationHeaderOptions } from "../../../common/navigationHeaderOptions";

export const TaskExecutionInstructions = withWebModal(() => {
  const intl = useIntl();
  const getHeader = useNavigationHeaderOptions();
  return (
    <TaskExecutionInstructionsStack.Navigator>
      <TaskExecutionInstructionsStack.Screen
        component={TaskExecutionInstructionsScreen}
        name="TaskExecutionInstructions"
        options={({ navigation }) => ({
          ...getHeader({
            type: "CLOSE",
            onClose: () => navigation.goBack(),
            title: intl.formatMessage({
              defaultMessage: "Instructions",
              description: "TaskInstructions: header",
            }),
          }),
        })}
      />
    </TaskExecutionInstructionsStack.Navigator>
  );
}, true);
